export const inCabList = [
  'Inspect security of all fittings /controls / panels',
  'Inspect condition of pedals / surface / rubber covers / pivot security',
  'Inspect seats / belts / covers for correct operation and condition',
  'Inspect low air buzzer / warning devices',
  'Lubricate door locks / striker / travel limiters',
  'Inspect operations of all gauges & dash lights',
  'Check presence of first aid kit & expiry date / spill kits / triangles',
  'Check operation of wipers / washers / horns / lights / Reverse Beeper'
];

export const truckExternalList = [
  'Inspect all lights for security / condition operation',
  'Inspect mudflaps for security / condition',
  'Inspect reflectors for security / condition',
  'Inspect battery security / water levels / terminals / ISO / cover',
  'Inspect all fittings / brackets / tanks / hose fittings',
  'Inspect tyres, wheels for compliance with load rating, fitment, pressures / nut indicators',
  'Check operation of reverse beeper / camera and adjust if required',
  'Check all harness / hose / pipe security',
];

export const engineCompartmentList = [
  'Inspect belts for tension / cracks / alignment',
  'Inspect radiator cap, hose out radiator and charge air coolers, check for contamination, leaks and damage. Check all hoses for leaks / splits / hardness / fitment / condition and security',
  'Blow out radiator',
  'Inspect pulleys, idlers and adjusters, fan hubs and vibration dampers for movement, lubricate hub bearings where required',
  'Inspect and report source of oil / fuel / air leaks',
  'Check air compressor mounting nuts (ISC, ISL) & DAL LF',
  'Inspect power steer oil level leaks and system condition',
  'Check engine oil levels',
];

export const underVehicleList = [
  'Inspect units / yokes / centre bearing for movement / security',
  'All vehicles, inspect steering joints / arms / links / lock nuts / idlers etc.',
  'Inspect steering box and pitman arm security',
  'Inspect all hangers / mounts for security',
  'Inspect spring leaves for cracks / sagging',
  'Inspect slippers for wear and security',
  'Inspect all pins / bolts / bushes for wear and correct shimming',
  'Inspect shocks for leaks / damage / security',
  'Grease all points and ensure acceptance',
  'Inspect air bags / trailing arms / bolsters for abnormalities',
  'Inspect air tanks security and condition',
  'Inspect brake lining & pad thickness & record (Table A)',
  'Inspect wiring and air harness for security and chaffing',
  'Inspect hydraulic hoses for security and chaffing',
  'Drain air tanks and service air dryer and replace filter',
  'Inspect and report loose chassis, body bolts and brackets Inc. re tension',
  'Inspect battery cables for security and chaffing',
  'Inspect fuel tank security and condition also inspect repair and report any oil / fuel system leaks',
];

export const bodyList = [
  'Check body for cracks / lids / rear door hinge & Locks / arms / forks / body - check all top door and rear door pins',
  'Check rubber bin and arm stops for ware and cracks',
  'Check and grease all pins top doors / rear door / compaction blade pins and check Hydraulic oil tank level and fill if required',
  'Check for any cylinder Hydraulic leaks and report',
  'Check condition and operation of lift arms / lids / tilt cylinders',
];

export const axlesList = [
  'Axle 1 Full lining / Pad Thickness mm',
  'Axle 2 Full lining / Pad Thickness mm',
  'Axle 3 Full lining / Pad Thickness mm',
  'Axle 4 Full lining / Pad Thickness mm',
  'Axle 5 Full lining / Pad Thickness mm',
  'Axle 6 Full lining / Pad Thickness mm',
];
